import { render, staticRenderFns } from "./InterestedBuyerRegistration.vue?vue&type=template&id=219ba93c&scoped=true&"
import script from "./InterestedBuyerRegistration.vue?vue&type=script&lang=js&"
export * from "./InterestedBuyerRegistration.vue?vue&type=script&lang=js&"
import style0 from "./InterestedBuyerRegistration.vue?vue&type=style&index=0&id=219ba93c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219ba93c",
  null
  
)

export default component.exports